<cm-message-indicator
  [unreadQueue]="unreadMessageRecipients$ | async"
></cm-message-indicator>

